import type { ListingCompDto } from '@zg-rentals/ts-customer-analytics-client';

export const isValidCompPrice = (comp: ListingCompDto): boolean => !comp.isUnclaimed;
